import { ReactComponent as Data } from 'assets/icons/icon-data.svg';

export default Data;
